import { gql } from "@apollo/client";

export const GetFactors = gql`
  query GetFactors {
    factors {
      name
      description
      subFactors {
        name
        description
        longDescription
      }
    }
  }
`;
